<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div
        class="page-actions"
        style="display: flex; justify-content: space-between"
      >
        <div class="select">
          <!-- <div class="item">
            <div class="ipt">
              币种开关：
              <el-switch v-model="coinSwitch" active-text="开" inactive-text="关">
              </el-switch>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              划转开关：
              <el-switch v-model="transferSwitch" active-text="开" inactive-text="关">
              </el-switch>
            </div>
          </div> -->
          <!-- <div class="item">
            <div class="ipt">
              <el-input placeholder="币种ID" clearable v-model="id"> </el-input>
            </div>
          </div> -->
          <div class="item">
            <div class="ipt">
              <el-select v-model="type" placeholder="币种类型" size="mini">
                <el-option
                  v-for="item in typeList"
                  :key="item.key"
                  :label="item.label"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <el-button
              size="mini"
              type="primary"
              @click="handleSearch({ page: 1 })"
              >查询</el-button
            >
          </div>

          <div class="item">
            <el-button size="mini" type="primary" @click="show('新增')"
              >新增交易对</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="900">
        <el-table-column label="币种" prop="coin" />
        <el-table-column label="币种类型" prop="type" />
        <el-table-column prop="" label="币种开关">
          <template slot-scope="scope">
            <span>{{ scope.row.coinSwitch ? "开" : "关" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="划转开关">
          <template slot-scope="scope">
            <span>{{ scope.row.transferSwitch ? "开" : "关" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="创建时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="show('编辑', scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :total="total"
        :page="pagination.page"
        @pageChanged="paginationHandle"
      >
      </pagination>

      <el-dialog
        :title="title"
        :visible="dialogVisible"
        width="400px"
        @close="close"
        :destroy-on-close="true"
      >
        <el-form
          ref="formData"
          :model="formData"
          size="medium"
          label-width="100px"
        >
          <el-form-item label="币种开关" prop="">
            <el-switch v-model="formData.coinSwitch"> </el-switch>
          </el-form-item>
          <el-form-item label="划转开关" prop="">
            <el-switch v-model="formData.transferSwitch"> </el-switch>
          </el-form-item>
          <el-form-item label="币种类型" prop="">
            <el-select
              v-model="formData.type"
              @change="typeChange"
              placeholder="币种类型"
            >
              <el-option
                v-for="item in typeList"
                :key="item.key"
                :label="item.label"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="币种ID" prop="">
            <el-select v-model="formData.coin" placeholder="币种ID">
              <el-option
                v-for="item in coinArr"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <div class="title" @click="add">新增提现手续费配置</div>
          <el-form-item
            label=""
            prop=""
            v-for="(item, index) in formData.withdrawConf"
            :key="index"
          >
            <el-input
              placeholder="请输入内容"
              v-model="item.WithdrawFee"
              class="input-with-select"
            >
              <el-select
                v-model="item.chain"
                slot="prepend"
                placeholder="请选择"
                class="w120"
              >
                <el-option
                  :label="i"
                  :value="i"
                  v-for="i in choinaArr"
                  :key="i"
                ></el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="handleSave">确定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api.js";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      // coinSwitch: false,
      // transferSwitch: false,
      // id: "",
      typeList: [
        { label: "现货", key: "SPOT" },
        { label: "合约", key: "CONTRACT" },
      ],
      type: "SPOT",
      tabList: [],
      total: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      dialogVisible: false,
      title: "新增",
      formData: {
        coinSwitch: false,
        transferSwitch: false,
        id: "",
        type: "",
        coin: "",
        withdrawConf: [],
      },
      coinArr: [],
      choinaArr: [],
    };
  },
  computed: {},
  mounted() {
    api.tenantChainist().then((res) => {
      if (res.code == 0) {
        this.choinaArr = res.data;
      }
    });
    this.handleSearch();
  },
  methods: {
    typeChange(val) {
      this.getCoinList();
    },
    getCoinList() {
      api.coinList({ type: this.formData.type }).then((res) => {
        res.code == 0 && (this.coinArr = res.data);
      });
    },
    handleSearch(data = {}) {
      api
        .getUserList({
          // id: this.id,
          // coinSwitch: this.coinSwitch,
          // transferSwitch: this.transferSwitch,
          type: this.type,
          ...this.pagination,
          ...data,
        })
        .then((res) => {
          if (res.code == 0) {
            const { totalCount, list } = res.data;
            this.tabList = list;
            this.total = totalCount;
          }
        });
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.handleSearch();
    },
    show(str, row) {
      if (row) {
        this.formData.coinSwitch = row.coinSwitch;
        this.formData.transferSwitch = row.transferSwitch;
        this.formData.id = row.id;
        this.formData.type = row.type;
        this.formData.coin = row.coin;
        if (row.withdrawConf) {
          this.$set(
            this.formData,
            "withdrawConf",
            JSON.parse(row.withdrawConf)
          );
        } else {
          this.$set(this.formData, "withdrawConf", []);
        }
      }
      this.title = str;
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
      this.coinArr = [];
      this.formData = {
        coinSwitch: false,
        transferSwitch: false,
        id: "",
        type: "",
        coin: "",
      };
    },
    handleSave() {
      let a = {
        ...this.formData,
        withdrawConf: JSON.stringify(this.formData.withdrawConf),
      };
      if (this.formData.type == "") {
        return this.$message.error("请选择币种类型");
      }
      if (this.formData.coin == "") {
        return this.$message.error("请选择币种ID");
      }
      api
        .coinUpdate({
          ...this.formData,
          withdrawConf: JSON.stringify(this.formData.withdrawConf),
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success(this.title + "成功");
            this.close();
            this.handleSearch();
          }
        });
    },
    add() {
      let arr = this.formData.withdrawConf;
      arr.push({ chain: "", WithdrawFee: 1 });
      this.$set(this.formData, "withdrawConf", arr);
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style lang="less" scoped>
.title {
  margin-bottom: 8px;
  color: red;
  cursor: pointer;
}
/deep/ .el-input-group {
  width: 85%;
}
/deep/ .el-select--medium.w120 {
  width: 120px;
}
</style>
